<template>
  <div class="learningstatistics">
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="报名明细数据" name="first">
        <div class="header">
          <!-- <el-input v-model="params.searchValue" clearable :placeholder="$t('Education.languages16')+$t('Education.languages10')+$t('Education.languages01')" style="width: 300px;margin-right: 30px"></el-input>
          <el-button type="primary" @click="searchgetStudyStatistics()">{{ $t('Education.languages01') }}</el-button>
          <el-button type="primary" @click="ClickExport">{{ $t('Education.languages20') }}</el-button> -->
          <el-form :inline="true" :model="params" class="demo-form-inline">
            <el-form-item label="综合查询">
              <el-input v-model="params.searchValue" placeholder="账号/姓名/手机号/身份证号"></el-input>
            </el-form-item>

            <el-form-item label="部门">
              <el-cascader ref="wcascader" @change="Selected_to_shut_dow" v-model="DeptID" @expand-change="bumen"
                filterable :options="optionsnew" :props="{ checkStrictly: true }" clearable ></el-cascader>
            </el-form-item>

            <el-form-item label="报名情况">
              <el-select v-model="params.enrolled" placeholder="报名情况">
                <el-option label="全部" value=""></el-option>
                <el-option label="已报名" value="1"></el-option>
                <el-option label="未报名" value="2"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="学习情况">
              <el-select v-model="params.studyProgress" placeholder="学习情况">
                <el-option label="全部" value=""></el-option>
                <el-option label="已完成" value="1"></el-option>
                <el-option label="未完成" value="2"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" @click="params.excelFlag = '2',searchgetStudyStatistics()">查询</el-button>
              <el-button type="primary" @click="czfun1()">重置</el-button>
              <el-button type="primary" @click="params.excelFlag = '1',searchgetStudyStatistics()">导出</el-button>
            </el-form-item>

          </el-form>
        </div>

        <div class="content">
          <el-table v-loading="loadings" :data="studyData" :cell-style="{'text-align':'center'}" style="width: 100%">
            <el-table-column prop="userId"     label="学生学号"></el-table-column>
            <el-table-column prop="realName"   label="学生姓名"></el-table-column>
            <el-table-column prop="sex"        label="性别"></el-table-column>
            <el-table-column prop="degree"     label="学历"></el-table-column>
            <el-table-column prop="deptName"   label="部门"></el-table-column>
            <el-table-column prop="enrolled"   label="报名情况"></el-table-column>
            <el-table-column prop="totalHours" label="总课时"></el-table-column>
            <!-- <el-table-column prop="trainName" label="培训主题"></el-table-column>
            <el-table-column prop="courseName" label="课程名称"></el-table-column> -->
            <el-table-column label="占比">
              <template v-slot="scope">
                <el-col :span="18">
                  <el-progress :text-inside="true" :stroke-width="20" :color="stydycolor" :percentage="Number(scope.row.studyHoursProportion)"></el-progress>
                </el-col>
                <!-- <el-col :span="4" :offset="1">{{scope.row.totalHours}}</el-col> -->
              </template>
            </el-table-column>

          </el-table>
          
          <el-pagination style="margin-top: 20px;" hide-on-single-page @current-change="handleCurrentChange" :current-page.sync="params.pageNum" :page-size="params.pageSize" layout="total, prev, pager, next" :total="params.Total">
          </el-pagination>

        </div>
      </el-tab-pane>

      <el-tab-pane label="考试明细数据" name="second">
        <div class="header">
          <!-- 主题类型： -->
          <el-form :inline="true" class="demo-form-inline">

            <el-form-item label="综合查询">
              <el-input v-model="params2.searchValue" placeholder="账号/姓名/手机号/身份证号"></el-input>
            </el-form-item>

            <el-form-item label="部门">
              <el-cascader ref="wcascader2" @change="Selected_to_shut_dow2" v-model="DeptID2" @expand-change="bumen2"
                filterable :options="optionsnew2" :props="{ checkStrictly: true }" clearable></el-cascader>
            </el-form-item>

            <el-form-item label="试卷标题">
              <el-input v-model="params2.examTitle" placeholder="试卷标题"></el-input>
            </el-form-item>

            <el-form-item label="考试状态">
              <el-select v-model="params2.status" placeholder="考试状态">
                <el-option label="全部" value="全部"></el-option>
                <el-option label="待学习" value="待学习"></el-option>
                <el-option label="待考试" value="待考试"></el-option>
                <el-option label="待批阅" value="待批阅"></el-option>
                <el-option label="通过"   value="通过"></el-option>
                <el-option label="未通过" value="未通过"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="试卷类型">
              <el-select v-model="params2.examType" placeholder="试卷类型">
                <el-option label="培训考试" value="1"></el-option>
                <el-option label="课程考试" value="2"></el-option>
                <el-option label="章节考试" value="3"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="课程">
              <el-select v-model="params2.course" placeholder="课程" @change="kcqhfun()">
                <el-option v-for="(item,i) in kechengdata" :key="i" :label="item.courseName" :value="item.courseId"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="章节">
              <el-select v-model="params2.chapter" placeholder="章节">
                <el-option v-for="(item,i) in chapters" :key="i" :label="item.chapterName" :value="item.chapterId"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" @click="params2.excelFlag = '2',search()">查询</el-button>
              <el-button type="primary" @click="czfun2()">重置</el-button>
              <el-button type="primary" @click="params2.excelFlag = '1',search()">导出</el-button>
            </el-form-item>

          </el-form>
        </div>

        <div class="content">
          <el-table v-loading="loadings2" :data="Examstatistics2" :cell-style="{'text-align':'center'}" style="width: 100%;text-align: center">
            <el-table-column prop="userId" label="学号"></el-table-column>
            <el-table-column prop="realName" label="姓名"></el-table-column>
            <el-table-column prop="sex" label="性别"></el-table-column>
            <el-table-column prop="degree" label="学历"></el-table-column>
            <el-table-column prop="deptName" label="部门"></el-table-column>
            <el-table-column prop="examType" label="试卷类型"></el-table-column>
            <el-table-column prop="examTitle" label="试卷标题"></el-table-column>
            <el-table-column prop="examTime" label="考试时间"></el-table-column>
            <el-table-column label="考试状态">
              <template v-slot="scope">
                <span>{{scope.row.examStatus}}</span>
              </template>
            </el-table-column>
            <el-table-column label="分数">
              <template v-slot="scope">
                <span v-if="scope.row.examScore == 0 || scope.row.examScore == null">--</span>
                <span v-else class="operateitem" @click="$router.push('scoredetail?examRecordId='+scope.row.examRecordId)">{{scope.row.examScore}}</span>
              </template>
            </el-table-column>

            <el-table-column label="操作" show-overflow-tooltip width="160px">
              <template slot-scope="scope">
                <span class="w" v-if="scope.row.isMarkingPapers == 1"  @click="Read_over(scope.row)">批阅</span>
              </template>
            </el-table-column>

            <!-- <el-table-column :label="$t('Education.languages42')">
              <template v-slot="scope">
                <span v-if="scope.row.examStatus!=2">--</span>
                <span v-else class="operateitem" @click="$router.push('papergrad?examRecordId='+scope.row.examRecordId)">{{ scope.row.examScore?$t('Education.languages75'):$t('Education.languages74') }}</span>
              </template>
            </el-table-column>占比 -->

          </el-table>

          <el-pagination style="margin-top: 20px;" hide-on-single-page @current-change="handleCurrentChange2" :current-page.sync="params2.pageNum" :page-size="params2.pageSize" layout="total, prev, pager, next" :total="params2.Total">
          </el-pagination>

        </div>
      </el-tab-pane>

      <el-tab-pane label="通过明细数据" name="three">
       <div v-loading="Certificateissuanceload" element-loading-text="证书颁发中···，请不要进行其他操作！">
        <div class="header">
          <el-form :inline="true" class="demo-form-inline">

            <el-form-item label="综合查询">
              <el-input v-model="baoming.name" placeholder="账号/姓名/手机号/身份证号"></el-input>
            </el-form-item>

            <el-form-item label="部门">
              <el-cascader ref="wcascader2" @change="Selected_to_shut_dow3" v-model="DeptID3" @expand-change="bumen3"
                filterable :options="optionsnew3" :props="{ checkStrictly: true }" clearable ></el-cascader>
            </el-form-item>

            <el-form-item label="是否通过">
              <el-select v-model="baoming.passStatus" placeholder="活动区域">
                <el-option label="全部" value=""></el-option>
                <el-option label="通过" value="通过"></el-option>
                <el-option label="未通过" value="未通过"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" @click="baoming.excelFlag = '2',outime()">查询</el-button>
              <el-button type="primary" @click="czfun3()">重置</el-button>
              <el-button type="primary" @click="baoming.excelFlag = '1',outime()">导出</el-button>
              <el-button type="primary" @click="allfun(2)">选中颁发</el-button>
              <el-button type="primary" @click="allfun(3)">一键颁发</el-button>
            </el-form-item>

          </el-form>
        </div>

        <div class="content">
          <el-table v-loading="loadings3" :data="Examstatistics3" :cell-style="{'text-align':'center'}" 
          style="width: 100%;text-align: center" @selection-change="handleSelectionChange">
            <el-table-column type="selection"  width="55" :selectable="handleDisable"></el-table-column>
            <el-table-column prop="userID" label="学号"></el-table-column>
            <el-table-column prop="realName" label="姓名"></el-table-column>
            <el-table-column prop="sex" label="性别"></el-table-column>
            <el-table-column prop="deptName" label="部门名称"></el-table-column>
            <el-table-column prop="degree" label="学历"></el-table-column>
            <el-table-column prop="trainName" label="培训名称"></el-table-column>
            <el-table-column prop="passState" label="是否通过"></el-table-column>
            <el-table-column prop="certTime" label="颁发时间"></el-table-column>

            <el-table-column label="操作" show-overflow-tooltip width="160px">
              <template slot-scope="scope">
                <span>{{scope.row.trainId}}</span>
                <el-button v-if="scope.row.passState == '通过' && scope.row.certUrl == '1'" type="text" :disabled = "hiojxsl" @click="allfun(1,scope.row)">颁发证书</el-button>
                <span v-if="scope.row.passState == '通过' && scope.row.certUrl == '2'" class="w">已颁发</span>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <el-pagination style="margin-top: 20px;" hide-on-single-page @current-change="handleCurrentChange3" :current-page.sync="baoming.pageNum" :page-size="baoming.pageSize" layout="total, prev, pager, next" :total="baoming.Total"></el-pagination>
       </div>

        <div ref="content" class="certificate">
          <img v-if="imgurl" :src="imgurl" style="position: absolute;top: 0;left: 0;width: 100%;height: 100%;z-index: 0;">
          <img v-else src="../../assets/30eb4ceb3e62c23bc90bf7b3a065922.png" alt="" style="position: absolute;top: 0;left: 0;width: 100%;height: 100%;z-index: 0;">
          <div style="position: relative;z-index: 2;">
            <img style="width: 40px;height: 40px;margin-top:40px;margin-left:32px;" src="../../assets/26e55c391edca1734eda330566f9810.png" alt="">
            <h3 style="color: #fff;font-family: 'SourceHanSerifCN-Bold-2',sans-serif !important;margin-left:80px;margin-top:-42px;font-size: 13px;">中国科学院大学心理健康教育中心</h3>
            <p style="color: #fff;font-family: 'SourceHanSerifCN-Bold-2',sans-serif !important;margin-left:80px;margin-top:0px;font-size: 10px;">Mental Health Education Center, UCAS</p>
            <h2 style="text-align:center;color: #fff;margin-top:20px;font-family: 'SourceHanSerifCN-Bold-2',sans-serif !important;font-size: 34px;letter-spacing:1px">课程证书</h2>
            <p style="text-align:center;color: #fff;margin-top:10px;font-family: 'SourceHanSerifCN-Bold-2',sans-serif !important;">Certificate of completion</p>
            <h4 style="text-align:center;color: #fff;margin-top:20px;font-family: 'SourceHanSerifCN-Bold-2',sans-serif !important;font-size: 20px;">{{certificateContentdata.realName}}</h4>
            <p style="text-align:center;color: #fff;margin-top:10px;font-family: 'SourceHanSerifCN-Bold-2',sans-serif !important;">身份证号:{{certificateContentdata.idCard}}</p>

            <p style="text-align:left;color: #fff;margin-top:10px;width: 86%;margin-left:7%;line-height:26px;font-family: 'SourceHanSerifCN-Bold-2',sans-serif !important;text-indent:24px;letter-spacing:1px">恭喜您于{{certificateContentdata.trainTime}}，参加中国科学院大学心理健康教育中心举办的 "{{certificateContentdata.trainName}}"集中学习，按规定修完教学计划的全部内容，完成{{certificateContentdata.lessonHours}}学时。</p>
            <!-- 8.30杨菊 -->

            <p style="text-align:left;color: #fff;margin-top:10px;margin-left:7%;font-size: 16px;font-family: 'SourceHanSerifCN-Bold-2',sans-serif !important;text-indent:24px;letter-spacing:1px">特发证书</p>
            <h5 style="text-align:right;color: #fff;margin-top:30px;margin-right:7%;font-size: 16px;font-family: 'SourceHanSerifCN-Bold-2',sans-serif !important;letter-spacing:1px">中国科学院大学心理健康教育中心</h5>
            <p style="text-align:right;color: #fff;margin-top:10px;margin-right:7%;font-size: 16px;font-family: 'SourceHanSerifCN-Bold-2',sans-serif !important;">{{formatChineseDateTime(new Date())}}</p>
          </div>
        </div>


          

      </el-tab-pane>
    </el-tabs>

    <el-drawer title="我是标题" size="50%" :visible.sync="drawer" :with-header="false">
      <p style="padding: 20px 10px;font-size: 16px;">考生学号：{{spdata.userID}}   姓名：{{spdata.realName}}</p>
      <el-descriptions class="margin-top" :column="1" border style="width: 98%;margin-left:1%;padding-top:20px">
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-user"></i>
            课程
          </template>
          {{spdata.relName}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-mobile-phone"></i>
            考试标题
          </template>
          {{spdata.examTitle}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-location-outline"></i>
            问答题1
          </template>
          {{spdata.examQuestionNum}}题 每题{{spdata.examQuestionScore}}分
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-tickets"></i>
            问答题总分
          </template>
          {{spdata.examQuestionScore * spdata.examQuestionNum}}
        </el-descriptions-item>
      </el-descriptions>

      <div style="width: 98%;margin-left:1%;border-bottom:1px dashed #8f8f8f;margin-top:20px"></div>

      <div style="width: 98%;margin-left:1%;margin-top:20px">
        <h3 style="text-align:Center;font-size: 20px;">{{spdata.examTitle}}</h3>
        <p style="font-size: 16px;">问答题 <span style="color: #8f8f8f;">（总共{{spdata.examQuestionNum}}题，每题{{spdata.examQuestionScore}}分，总共{{spdata.examQuestionScore * spdata.examQuestionNum}}分）</span></p>

        <ul style="padding-bottom:50px">
          <li style="font-size: 14px;" v-for="(item, i) in spdata.questionInfos" :key="i">

            <p style="padding:10px">{{i+1}}.{{item.questionTitle}}</p>
            <p style="padding:0px 20px;color: #8f8f8f;line-height:24px">{{item.userAnswer}}</p>
            <p style="padding:20px 20px;">得分：<el-input-number style="height: 15px;" v-model="item.userQuestionScore" size="small" :min="1" :max="spdata.examQuestionScore" label="描述文字"></el-input-number></p>
          </li>
        </ul>

        <el-button type="primary" @click="spqdfun()" style="margin-left:45%">确定</el-button>
      </div>
    </el-drawer>

    <div ref="content" class="certificate" id="myElement" >
      <img v-if="imgurl" :src="imgurl" style="position: absolute;top: 0;left: 0;width: 100%;height: 100%;z-index: 0;">
      <img v-else src="../../assets/30eb4ceb3e62c23bc90bf7b3a065922.png" alt="" style="position: absolute;top: 0;left: 0;width: 100%;height: 100%;z-index: 0;">
      <div style="position: relative;z-index: 2;">
        <img style="width: 40px;height: 40px;margin-top:40px;margin-left:32px;" src="../../assets/26e55c391edca1734eda330566f9810.png" alt="">
        <h3 style="color: #fff;font-family: 'SourceHanSerifCN-Bold-2',sans-serif !important;margin-left:80px;margin-top:-42px;font-size: 13px;">中国科学院大学心理健康教育中心</h3>
        <p  style="color: #fff;font-family: 'SourceHanSerifCN-Bold-2',sans-serif !important;margin-left:80px;margin-top:0px;font-size: 10px;">Mental Health Education Center, UCAS</p>
        <h2 style="text-align:center;color: #fff;margin-top:20px;font-family: 'SourceHanSerifCN-Bold-2',sans-serif !important;font-size: 34px;letter-spacing:1px">课程证书</h2>
        <p style="text-align:center;color: #fff;margin-top:10px;font-family: 'SourceHanSerifCN-Bold-2',sans-serif !important;">Certificate of completion</p>
        <h4 style="text-align:center;color: #fff;margin-top:20px;font-family: 'SourceHanSerifCN-Bold-2',sans-serif !important;font-size: 20px;">{{certificateContentdata.realName}}</h4>
        <p style="text-align:center;color: #fff;margin-top:10px;font-family: 'SourceHanSerifCN-Bold-2',sans-serif !important;">身份证号:{{certificateContentdata.idCard}}</p>
        <p style="text-align:left;color: #fff;margin-top:10px;width: 86%;margin-left:7%;line-height:26px;font-family: 'SourceHanSerifCN-Bold-2',sans-serif !important;text-indent:24px;letter-spacing:1px">恭喜您于{{certificateContentdata.trainTime}}，参加中国科学院大学心理健康教育中心举办的 "{{certificateContentdata.trainName}}"集中学习，按规定修完教学计划的全部内容，完成{{certificateContentdata.lessonHours}}学时。</p>
        <p style="text-align:left;color: #fff;margin-top:10px;margin-left:7%;font-size: 16px;font-family: 'SourceHanSerifCN-Bold-2',sans-serif !important;text-indent:24px;letter-spacing:1px">特发证书</p>
        <h5 style="text-align:right;color: #fff;margin-top:30px;margin-right:7%;font-size: 16px;font-family: 'SourceHanSerifCN-Bold-2',sans-serif !important;letter-spacing:1px">中国科学院大学心理健康教育中心</h5>
        <p style="text-align:right;color: #fff;margin-top:10px;margin-right:7%;font-size: 16px;font-family: 'SourceHanSerifCN-Bold-2',sans-serif !important;">{{formatChineseDateTime(new Date())}}</p>
      </div>
    </div>
  </div>
</template>
<script>

import html2canvas from 'html2canvas'
export default {
  components: { html2canvas },
  name:'learningstatistics',
  data() {
    return {
      hiojxsl:false,
      aaaid:'',
      spdata:[],
      num:'',
      drawer:false,
      tgfunload:true,
      fornum:1,
      stidata:[],
      examRecordIdlist:[],
      certificateContentdata:[],
      courseId:'',
      chapters:[],
      params2:{
        pageNum: 1,
        pageSize: 10,
        searchValue: "",
        status:'待批阅',
        trainId: this.$route.query.trainId,
        deptld:'',
        examType:'',
        examTitle:'',
        course:'',
        chapter:'',
        excelFlag:'2',//1是导出
      },
      baoming:{
        pageNum:1,
        pageSize:10,
        deptID:'',
        passStatus:'',
        name:'',
        Total:0,
        trainId: this.$route.query.trainId,
        excelFlag:'2',//1是导出
      },
      optionsnew:[],
      optionsnew2:[],
      optionsnew3:[],
      DeptID:'',
      DeptID2:'',
      DeptID3:'',
      activeName: 'first',
      loadings:true,
      actionUrl:process.env.VUE_APP_URL,
      params:{
        pageNum:1,
        pageSize:10,
        Total:0,
        searchValue:'',
        trainId:this.$route.query.trainId,
        enrolled:'',
        studyProgress:'',
        searchValue:'',
        excelFlag:'2',//1是导出
      },
      studyData:[],
      stydycolor:[
        {color: '#f56c6c', percentage: 20},
        {color: '#e6a23c', percentage: 40},
        {color: '#ff882c', percentage: 60},
        {color: '#1989fa', percentage: 80},
        {color: '#3ea660', percentage: 100}
      ],
      kechengdata:[],
      loadings2:true,
      loadings3:true,
      Examstatistics2:[],
      Examstatistics3:[],
      examstate:[
        {label:'未参加',value:'0'},
        {label:'正在考试',value:'1'},
        {label:'考试结束',value:'2'}
      ],
      questionInfos:[],
      xzbbfunload:false,
      alluid:[],
      RemainingQuantity:0,
      Certificateissuanceload:false,
      imgurl:'',
      formData:new FormData(),
      formDateDetail:[],
      offlineApplicationDetails:[]
    }
  },
  watch:{
    RemainingQuantity(newval,oldval){
      if(newval != 0 && newval <= this.alluid.length){
        this.certificateContentdata = {
          ...this.certificateContentdata,
          realName: this.alluid[newval - 1].realName,
          idCard: this.alluid[newval - 1].idCard,
          trainTime: this.alluid[newval - 1].trainTime,
          trainName: this.alluid[newval - 1].trainName,
          lessonHours: this.alluid[newval - 1].lessonHours,
        };
        this.$nextTick(() => {
          html2canvas(this.$refs.content, { dpi: 72, scale: 2, useCORS: true }).then(canvas => {
            const img = canvas.toDataURL("image/jpeg");
            const file = this.base64ToFile(img, this.alluid[newval-1].userID);
            this.formData.append(`images`,file);
            let DateList={
                stuID: this.alluid[newval-1].userID,
                trainId: this.$route.query.trainId,
                certUrl: '',
                certType: '1',
                examMethod: '2'
            }
            console.log(DateList)
            this.formDateDetail.push(DateList);
            this.RemainingQuantity++;
          });
        });
      }else if(newval > this.alluid.length){
        this.formData.append(`enrollData`,JSON.stringify(this.formDateDetail));
        this.uploadCert();
      }
    }
  },
  mounted(){
    this.$Http_Post('/certificateTemplate/selected',{templateType:2}).then((res)=>{
      if (res.Code == 200 || res.Code == 0) {
        let originalUrl= res.Data.templateBack;
        this.imgurl=originalUrl.replace(':8095', ':8020')
        document.getElementById("myElement").style.backgroundImage = `url(${this.imgurl})`;
      } else {
        this.Global.request_failure(res.Message);
      }
    })
  },
  methods: {
    spqdfun(){
      this.questionInfos = []
      for(var i = 0;i < this.spdata.questionInfos.length;i++){
        this.questionInfos.push(
          {
            "examRecordDetailId":this.spdata.questionInfos[i].examRecordDetailId,  
            "userQuestionScore":this.spdata.questionInfos[i].userQuestionScore
          }
        )
      }
 
      this.$Http_Post('edu/examRecord/readOver', {examRecordId:this.aaaid,questionInfos:this.questionInfos}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.drawer = false;
          this.Global.request_successful(res.Message);
          this.getExamStatistics2();
        } else {
          this.Global.request_failure(res.Message);
        }
      })

    },
    formatChineseDateTime(date) {
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      return `${year}年${month}月`;
    },
    base64ToFile (base64Data,userID){
      // 将base64的数据部分提取出来
      const arr = base64Data.split(',');
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      // 将Uint8Array转换为Blob对象
      const blob = new Blob([u8arr], { type: mime });
      // 创建File对象
      const file = new File([blob], userID + '.jpg', { type: mime });
      return file;
    },

    Read_over(row){
      this.aaaid = row.examRecordId.toString()
      this.drawer = true;
      this.$Http_Post('edu/examRecord/getReadOverInfo', {examRecordId: row.examRecordId.toString()}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.spdata = res.Data
        } else {
          this.Global.request_failure(res.Message);
        }
      })

    },

    // 颁发选中
    xzbbfun(){
      if (this.RemainingQuantity==0) {
        this.$message.warning('请选择需要颁发的学员');
        return;
      }
      this.Certificateissuanceload = true;
      this.certificateContent();
    },

    // 一键颁发
    allfun(type,row) {
      if(type == 1){
        this.alluid=[row];
      }else if(type == 2){
        if (this.alluid.length==0) {
          this.$message.warning('请选择需要颁发的学员');
          return;
        }
      }else if(type == 3){
        this.alluid = this.offlineApplicationDetails.filter(element => element.status == 0); // 提取 userID
        if (this.RemainingQuantity>=this.alluid.length || this.alluid.length == 0) {
          this.$message.warning('已颁发完成');
          return;
        }
      }
      this.Certificateissuanceload = true;
      this.RemainingQuantity++
    },

    // 颁发证书
    uploadCert(){
      this.$Http_Post('edu/app/uploadCert',this.formData).then((res) => {
        this.Certificateissuanceload = false;
        this.formDateDetail = [];
        this.formData = new FormData();
        this.RemainingQuantity = 0;
        if(res.Code == 200 || res.Code == 0){
          this.issueCertificatesList();
          this.Global.request_successful(res.Message);
        }else{
          this.Global.request_failure(res.Message);
        }
      })
    },

    handleDisable(row){
      // 1没颁发，2是已经颁发了
      if (row.passState == '通过' && row.certUrl == '1') {
        return true;
      } else {
        return false;
      }
    },
    handleSelectionChange(e){
      this.alluid=e;
    },

    Selected_to_shut_dow(dt,a) {
      this.DeptID = dt[dt.length - 1];
      this.$refs.wcascader.dropDownVisible = false;
    },
    Selected_to_shut_dow2(dt,a) {
      this.DeptID2 = dt[dt.length - 1];
      this.$refs.wcascader2.dropDownVisible = false;
    },
    Selected_to_shut_dow3(dt,a) {
      this.DeptID3 = dt[dt.length - 1];
      this.$refs.wcascader3.dropDownVisible = false;
    },
    GetNodeByDeptID(ID, NodeList) {
      let obj = null;
      for (let i = 0; i < NodeList.length; i++) {
        if (NodeList[i].DeptID == ID) {
          obj = NodeList[i];
          break;
        } else if (NodeList[i].fuzi && NodeList[i].children.length > 0 && NodeList[i].children[0].DeptID != '-1') {
          this.GetNodeByDeptID(ID, NodeList[i].children);
        }
      }
      return obj;
    },

    bumen(dt) {
      let obj = this.optionsnew[0];
      console.log(obj)
      for (let i = 0; i < this.optionsnew.length; i++) {
        if (this.optionsnew[i].DeptID == dt[dt.length - 1]) {
          obj = this.optionsnew[i];
          break;
        } else if (this.optionsnew[i].fuzi && this.optionsnew[i].children.length > 0 && this.optionsnew[i].children[0].DeptID != '-1') {
          obj = this.GetNodeByDeptID(
            dt[dt.length - 1],
            this.optionsnew[i].children
          );
        }
      }

      let _this = this;
      if (obj.fuzi && obj.children.length > 0 && obj.children[0].DeptID == '-1') {
        obj.children = [{ label: '数据加载中...'}];
        this.$Http_Post('/DepartMent/GetDeprtMentByNode',{DeptID:dt[dt.length - 1],content:''}).then((res) => {
          if (res.Code == 200 || res.Code == 0 && res.Data) {
            obj.children = res.Data;
          }
        });
      }

    },

    bumen2(dt) {
      let obj = this.optionsnew2[0];
      console.log(obj)
      for (let i = 0; i < this.optionsnew2.length; i++) {
        if (this.optionsnew2[i].DeptID == dt[dt.length - 1]) {
          obj = this.optionsnew2[i];
          break;
        } else if (this.optionsnew2[i].fuzi && this.optionsnew2[i].children.length > 0 && this.optionsnew2[i].children[0].DeptID != '-1') {
          obj = this.GetNodeByDeptID(
            dt[dt.length - 1],
            this.optionsnew2[i].children
          );
        }
      }

      let _this = this;
      if (obj.fuzi && obj.children.length > 0 && obj.children[0].DeptID == '-1') {
        obj.children = [{ label: '数据加载中...'}];
        this.$Http_Post('/DepartMent/GetDeprtMentByNode',{DeptID:dt[dt.length - 1],content:''}).then((res) => {
          if (res.Code == 200 || res.Code == 0 && res.Data) {
            obj.children = res.Data;
          }
        });
      }
    },

    bumen3(dt) {
      let obj = this.optionsnew3[0];
      for (let i = 0; i < this.optionsnew3.length; i++) {
        if (this.optionsnew3[i].DeptID == dt[dt.length - 1]) {
          obj = this.optionsnew3[i];
          break;
        } else if (this.optionsnew3[i].fuzi && this.optionsnew3[i].children.length > 0 && this.optionsnew3[i].children[0].DeptID != '-1') {
          obj = this.GetNodeByDeptID(
            dt[dt.length - 1],
            this.optionsnew3[i].children
          );
        }
      }
      let _this = this;
      if (obj.fuzi && obj.children.length > 0 && obj.children[0].DeptID == '-1') {
        obj.children = [{ label: '数据加载中...'}];
        this.$Http_Post('/DepartMent/GetDeprtMentByNode',{DeptID:dt[dt.length - 1],content:''}).then((res) => {
          if (res.Code == 200 || res.Code == 0 && res.Data) {
            obj.children = res.Data;
          }
        });
      }
    },

    handleClick(tab, event) {
      if(this.activeName == 'first'){
        this.getStudyStatistics();
      }else if(this.activeName == 'second'){
        this.getExamStatistics2();
        this.getExamDetailPc();
      }else if(this.activeName == 'three'){
        this.issueCertificatesList();
      }
    },

    getStudyStatistics(){
      this.loadings = true;
      this.params.DeptID = this.DeptID;
      this.$Http_Post('edu/train/getStudyStatistics',this.params).then(res=>{
        if(res.Code == 0 || res.Code == 200){
          if(this.params.excelFlag == 1){
            window.location.href = res.Data;
          }else{
            this.studyData = res.Data;
            this.params.Total = res.Counts;
            this.loadings = false;
          }
        }else{
          this.$message({type: 'error', message:res.Message});
        }
        this.loadings = false;
      });
    },

    outime(){
      this.baoming.pageNum = 1;
      this.loadings3 = true;
      this.issueCertificatesList();
    },

    kcqhfun(){
      this.getCourseDetailPc();
    },

    issueCertificatesList(){
      this.baoming.deptID = this.DeptID3
      this.$Http_Post('edu/train/issueCertificatesList',this.baoming).then(res=>{
        if(res.Code == 0 || res.Code == 200){
          if(this.baoming.excelFlag == 1){
            window.location.href = res.Data;
          }else{
            this.Examstatistics3 = res.Data;
            this.baoming.Total = res.Counts;
            this.loadings3 = false;
          }
        }else{
          this.$message({type: 'error', message:res.Message});
        }
        this.loadings3 = false;
        let Data=JSON.parse(JSON.stringify(this.baoming));
        Data.pageSize=-1;
        this.$Http_Post('edu/train/issueCertificatesList',Data).then(res=>{ 
          if(res.Code == 0 || res.Code == 200){
            this.offlineApplicationDetails=res.Data;
          }
        });
      });
    },
    searchgetStudyStatistics(){
      this.params.pageNum = 1;
      this.getStudyStatistics();
    },

    czfun1(){
      this.DeptID = ''
      this.params={
        pageNum:1,
        pageSize:10,
        Total:0,
        searchValue:'',
        trainId:this.$route.query.trainId,
        enrolled:'',
        studyProgress:'',
        searchValue:'',
        excelFlag:'2',//1是导出
      }
      this.getStudyStatistics();
    },

    czfun2(){
      this.DeptID2 = ''
      this.params2 = {
        pageNum: 1,
        pageSize: 10,
        searchValue: "",
        status:'',
        trainId: this.$route.query.trainId,
        deptld:'',
        examType:'',
        examTitle:'',
        course:'',
        chapter:'',
        excelFlag:'2',//1是导出
      },

      this.getExamStatistics2();
    },


    czfun3(){
      this.DeptID3 = ''
      this.baoming = {
        pageNum:1,
        pageSize:10,
        deptID:'',
        passStatus:'',
        name:'',
        Total:0,
        trainId: this.$route.query.trainId,
        excelFlag:'2',//1是导出
      },
      this.issueCertificatesList();
    },


    // 分页
    handleCurrentChange(val){
      this.params.pageNum = val;
      this.getStudyStatistics();
    },

    getExamStatistics2(){
      this.loadings2 = true;
      this.params2.chapter = this.params2.chapter.toString();
      this.params2.course = this.params2.course.toString();
      this.$Http_Post('edu/train/getExamStatistics',this.params2).then(res=>{
        if(res.Code==0 || res.Code == 200){
          if(this.params2.excelFlag == 1){
            window.location.href = res.Data;
          }else{
            this.Examstatistics2 = res.Data;
            this.params2.Total = res.Counts;
            this.loadings2 = false;
          }
        }else{
          this.$message({type: 'error', message:res.Message});
        }
        this.loadings2 = false;
      });
    },
    search(){
      this.params2.pageNum = 1;
      this.getExamStatistics2();
    },
    handleCurrentChange2(val){
      this.params2.pageNum = val;
      this.getExamStatistics2();
    },
    handleCurrentChange3(val){
      this.baoming.pageNum = val;
      this.issueCertificatesList();
    },

    getCourseDetailPc(){
      this.$Http_Post('edu/app/getCourseDetailPc', { courseId:this.courseId}).then((res) => {
        if(res.Code==0 || res.Code == 200){
          this.chapters = res.Data.chapters;
        }else{
          this.$message({type: 'error', message:res.Message});
        }
      });
    },

    getExamDetailPc(){
      this.$Http_Post('edu/app/getExamDetailPc', {pageIndex: '0',pageSize: '10',searchValue:'',trainID:this.$route.query.trainId}).then((res) => {
        if(res.Code==0 || res.Code == 200){
          if(res.Data){
            this.kechengdata = res.Data[0].courses;
            this.courseId = res.Data[0].courses[0].courseId.toString();
          }
        }else{
          this.$message({type: 'error', message:res.Message});
        }
      });
    }
  },

  created() {
    this.getStudyStatistics();
    this.$Http_Post('/DepartMent/GetDeprtMentByNode', { DeptID: '', content: ''}).then((res) => {
      if (res.Data) {
        this.optionsnew = res.Data;
        this.optionsnew2 = res.Data;
        this.optionsnew3 = res.Data;
      }
    });
  },
}
</script>
<style>

.learningstatistics{height: 100%;width: 100%;background-color: #fff;position: relative;}
.learningstatistics .header{display: flex;align-items:center;padding:0 30px;background: #fff;}
.learningstatistics .content{background:#fff;padding:0 30px;margin-top:20px;}
.learningstatistics .Proportion{padding:0 30px;}
.learningstatistics .Proportion span{background:#78bbff;color: #fff;display: inline-block;text-align: center;width: 50%;border-radius: 20px 0 0 20px;}
.learningstatistics .Proportion label{display: inline-block;text-align: center;width: 50%;border-radius:0 20px 20px 0;background:#ffd3a5;color: #fff;}
.learningstatistics .certificate{width: 320px;height: 649px;position: fixed;top:110px;left:300px;background-image: url('../../assets/30eb4ceb3e62c23bc90bf7b3a065922.png');background-size: 100% 100%;z-index: -1;}
</style>
